import {
	db,
	IModel,
	IVIPIpBase,
	VIPIpBase,
} from "@/loader";

/**
 * IP Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPIp extends IVIPIpBase {
}

/**
 * IP Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPIp extends VIPIpBase implements IVIPIp, IModel<IVIPIp> {
	constructor (data: IVIPIp = {}) {
		super(data);
	}

	public load(data: IVIPIp) {
		super.load(data);
	}

	public update(data: IVIPIp) {
		super.update(data);
	}

	public isParentOf(child: VIPIp): boolean {
		return this.children.some(c => {
			return child.id === c.id || c.isParentOf(child);
		});
	}

	public isDescendantOf(parent: VIPIp): boolean {
		return this.fk_parent === parent.id || this.parent?.isDescendantOf(parent) || false;
	}

	public toString(): string {
		return `${this.code} ${this.name}`;
	}

	/**
	 * Get Child IPs
	 */
	public get children(): VIPIp[] {
		return db.ips.list.filter(x => x.fk_parent === this.id).sort((a, b) => a.code.toString().localeCompare(b.code.toString()));
	}

	public parents(): VIPIp[] {
		if (!this.parent) {
			return [];
		}
		let result = [this.parent];
		result.push(...this.parent.parents());
		return result;
	}
}
